import React from 'react';

import { useLoaderData } from 'react-router-dom';

import AgreementsApp, { AgreementsData } from './AgreementsApp';

import ExpiredInvitation from '../ClientEnvelopeApprovals/ExpiredInvitation';

type ExpiredData = {
  expiredOrCancelled?: boolean;
};

type ValidData = AgreementsData & {
  expiredOrCancelled?: boolean;
};

type ClientEnvelopeApprovalData = ExpiredData | ValidData;

const ClientEnvelopeApprovalApp: React.FC = () => {
  const data = useLoaderData<ClientEnvelopeApprovalData>();

  if (!data || data.expiredOrCancelled) {
    return <ExpiredInvitation />;
  }

  return <AgreementsApp />;
};

export default ClientEnvelopeApprovalApp;
